// File Metadata:
// Filename: NewShipmentFormTU.js
// Version: 1.00
// Created: 2022-10-21 21:09:42
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import {
	Alert,
	Button,
	ButtonGroup,
	Card,
	CardContent,
	CardHeader,
	FilledInput,
	FormControl,
	FormLabel,
	Input,
	InputAdornment,
	InputLabel,
	TextField
} from '@mui/material'
import React, { Component } from 'react'
import LocalShipping from '@mui/icons-material/LocalShipping'

const VALID_TOUR_REGEX = /[0-9]{6}/

export class NewShipmentFormTU extends Component {
	state = {
		errMsg: '',
		tour: this.props.values.tour || ''
	}
	continue = e => {
		e.preventDefault();
		const { values } = this.props;
		
		// Only validate tour if required for this type
		const requiresTour = ['inbound', 'outbound', 'picklist', 'tour'].includes(values.type);
		
		if (requiresTour && !values.tour) {
			this.setState({ errMsg: 'Tour number is required for this shipment type' });
			return;
		}
		
		this.props.nextStep();
	}
	next = e => {
		e.preventDefault()

		const validTour = VALID_TOUR_REGEX.test(this.props.values.tour)
		if (!validTour) {
			//console.log(this.state.tour)
			//console.log(this.props.values.tour)
			return this.setState({ errMsg: 'Enter a valid tour number (6 digits)' })
		}
		if (validTour) {
			this.setState({ errMsg: '' })
			this.props.nextStep()
		}
	}
	back = e => {
		e.preventDefault()
		this.setState({ errMsg: '' })
		this.props.prevStep()
	}

	render() {
		const { values, handleChange } = this.props
		const requiresTour = ['inbound', 'outbound', 'picklist', 'tour'].includes(values.type);

		return (
			<Card sx={{ width: 345, minWidth: 200, boxShadow: 2, margin: 2 }}>
				<CardHeader 
					title="Enter Tour Number" 
					subheader={requiresTour ? "Required for this shipment type" : "Optional"} 
				/>
				<CardContent>
					{this.state.errMsg && <Alert severity='error'>{this.state.errMsg}</Alert>}
					<FormControl margin='normal' fullWidth variant='filled'>
						<InputLabel htmlFor='tournumber'>Tu - (000000)</InputLabel>
						<FilledInput
							id='tournumber'
							type='tel'
							value={values.tour}
							onChange={handleChange('tour')}
							required
							error={this.state.errMsg ? true : false}
							endAdornment={
								<InputAdornment position='end'>
									<LocalShipping />
								</InputAdornment>
							}
						/>
					</FormControl>
					<ButtonGroup fullWidth variant='contained'>
						<Button onClick={this.back}>Back</Button>
						<Button onClick={this.next}>Next</Button>
					</ButtonGroup>
				</CardContent>
			</Card>
		)
	}
}

export default NewShipmentFormTU
